module.exports = __webpack_public_path__ + "static/media/3.70e69659.jpg";